export default function IsValidName(name) {
  return (
    name && typeof name === "string" && name.replace(/[\d ]/g, "").length >= 2
  );
}
export function isNameSufficient(name, minLength = 3) {
  return name && typeof name === "string" && name.length >= minLength;
}
